export function capitalize(value: string) {
  return `${value[0].toUpperCase()}${value.slice(1)}`
}
